import { render, staticRenderFns } from "./AccommodatieHome.vue?vue&type=template&id=b8cc8978&"
import script from "./AccommodatieHome.vue?vue&type=script&lang=js&"
export * from "./AccommodatieHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports